import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=6a0ee168&scoped=true"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ee168",
  null
  
)

export default component.exports